/* Deployment-tier selector — radio cards on multi-variant product pages.
   The radios ARE the product form's variant input (name="id"), so add-to-cart works
   without JS. This script only mirrors the selection: price line + tier meta, the
   ADD_TO_CART availability/label, and ?variant= in the URL so reloads keep the tier.
   Money is never formatted here — every label was rendered by Liquid (snippets/price.liquid).
   Masterclass price line = snippets/dm-price.liquid (VAT spec §2): both lines are swapped
   from the radio's data-price-net / -tax / -sub; an empty piece hides its element. Without
   the dm-price markup (other products) the line is the plain data-price text. */
(function () {
  'use strict';

  function init() {
    var root = document.querySelector('[data-tier-selector]');
    if (!root) return;

    var form = root.closest('form');
    var priceEl = document.querySelector('[data-product-price]');
    var metaEl = document.querySelector('[data-tier-meta]');
    /* form.elements includes buttons outside the form that point at it with form="…"
       (the Masterclass second ADD_TO_CART above the fold), so both stay in sync */
    var addBtns = form ? Array.prototype.filter.call(form.elements, function (el) {
      return el.name === 'add';
    }) : [];

    function setPart(el, text) {
      if (!el) return;
      el.textContent = text;
      el.hidden = !text;
    }

    function setPrice(radio) {
      var gross = radio.getAttribute('data-price') || '';
      var amountEl = priceEl.querySelector('[data-price-amount]');
      if (!amountEl) {
        priceEl.textContent = gross;
        return;
      }
      amountEl.textContent = radio.getAttribute('data-price-net') || gross;
      setPart(priceEl.querySelector('[data-price-tax]'), radio.getAttribute('data-price-tax') || '');
      setPart(priceEl.querySelector('[data-price-sub]'), radio.getAttribute('data-price-sub') || '');
    }

    function apply(radio, updateUrl) {
      root.querySelectorAll('.dm-tier').forEach(function (tier) {
        tier.classList.toggle('is-selected', tier.contains(radio));
      });
      if (priceEl) setPrice(radio);
      if (metaEl) metaEl.textContent = radio.getAttribute('data-meta') || '';

      var available = radio.getAttribute('data-available') !== 'false';
      addBtns.forEach(function (addBtn) {
        addBtn.disabled = !available;
        var label = addBtn.getAttribute(available ? 'data-label-add' : 'data-label-sold-out');
        if (label) addBtn.textContent = label;
      });

      if (updateUrl && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', radio.value);
        window.history.replaceState(null, '', url.toString());
      }
    }

    root.addEventListener('change', function (event) {
      var radio = event.target.closest('input[data-tier-radio]');
      if (radio && radio.checked) apply(radio, true);
    });

    /* bfcache / form restoration can leave a different radio checked than Liquid rendered */
    var checked = root.querySelector('input[data-tier-radio]:checked');
    if (checked) apply(checked, false);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
